module.exports = __webpack_public_path__ + "static/media/jacob.b0c543cf.png";